module.exports = __webpack_public_path__ + "img/solutions-ch2-climate-justice.717efd53.svg";